/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Stack, Tab, Tabs, Typography } from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import CustomTabPanel from './TabPanel';
import LoadingContent from 'components/LoadingContent';
import ParentSum from 'screen/summary/components/ParentSum';
import StepParentSum from 'screen/summary/components/StepParentSum';
import LegalGuardianSum from 'screen/summary/components/LegalGuardianSum';
import ItemContent, { CheckboxContent } from 'screen/summary/components/ItemContent';
import { checkEnableParseJSON, formatBooleanToYesNo } from 'components/helper/helper';
import familyServices from 'services/familyServices';
import { householdOptions } from 'screen/family/household/Household';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { buildClassName, buildPageStatusClassName } from './RPersonalInformation';
import { getHousehold } from 'app/family/familySlice';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { routers } from 'router/router';
import { useHistory } from 'react-router-dom';
import websocketService from 'services/websocketService';
import { PAGE_NAME, USER_ROLE } from 'constants/common';
import pageStatusService from 'services/pageStatusService';
import { usePageStatus } from 'hooks/usePageStatus';
import { getAccessToken, getUserRole, removeAccessToken, removeUserId } from 'utils/sessionStorage';

const RFamily = ({
  setCurrentModuleId,
  isCounselor,
}: {
  setCurrentModuleId: (id: string) => void;
  isCounselor?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const history = useHistory();  
  const [value, setValue] = useState(1);
  const params: { id?: string | number } = useParams();
  const [isMobile, setIsMobile] = useState(false);

  let token = getAccessToken();

    // Use the custom hook for page status
  const { pageStatus } = usePageStatus({ studentId: params.id || '' });
  
  // Debug :
  console.log('pageStatus:', pageStatus);

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };  

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setCurrentModuleId(`2.${newValue}`);
  };

  useEffect(() => {
    setIsMobile(window.innerWidth <= 768);
  }, []);

  const checkModule = useAppSelector((store) => store.basicInformation.checkModule);
  const role = useAppSelector((store) => store.family.roleFamily);

  useEffect(() => {
    const getData = async () => {
      try {
        token = getAccessToken();
        if (token) {
          await dispatch(getHousehold(params.id)).unwrap();
        }
        else {
          handleLogout();
        }
      }
      catch(ex){
        console.log('Error: ', ex);
      }
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);  

  return (
    <div>
      <Tabs
        className='mt-2'
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          position: 'sticky',
          top: isCounselor ? '72px' : '0',
          left: 0,
          right: 0,
          zIndex: 11,
          backgroundColor: '#fff',
          borderBottom: '1px solid',
          borderColor: 'divider',
          paddingTop: '8px',
          paddingBottom: '8px',
          marginTop: 0,
          width: '100%',
          willChange: 'transform',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden',
        }}
      >
        <Tab value={1} label="Household" 
        // className={buildClassName('2.1', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.HOUSEHOLD)}
        />
        <Tab
          value={2}
          label="Parent 1"
          hidden={!role.parentNo1 || !isCounselor}
          // className={buildClassName('2.2', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.PARENT_1)}
        />
        <Tab
          value={3}
          label="Parent 2"
          hidden={!role.parentNo2 || !isCounselor}
          // className={buildClassName('2.3', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.PARENT_2)}
        />
        <Tab
          value={6}
          label="Step-Parent(s)"
          hidden={!(role.stepParent1 || role.stepParent2) || !isCounselor}
          // className={buildClassName('2.5', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.STEP_PARENT_1)}
        />
        <Tab
          value={5}
          label="Legal Guardian"
          hidden={!role.legalGuardian || !isCounselor}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.LEGAL_GUARDIAN)}
        />
        <Tab
          value={4}
          label="Siblings"
          hidden={!role.siblings || !isCounselor}
          // className={buildClassName('2.4', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.SIBLINGS)}
        />

      </Tabs>
      <CustomTabPanel value={value} index={1}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
            Household
          </Typography>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryHousehold isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          {/* <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
            Parent 1
          </Typography> */}
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryParent number={1} isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          {/* <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
            Parent 2
          </Typography> */}
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryParent number={2} isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      {/* Step Parent */}
      <CustomTabPanel value={value} index={6}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          {/* <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          Step Parent
          </Typography> */}
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryStepParent isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
            Siblings
          </Typography>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummarySiblings isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryLegalGuardian isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
    </div>
  );
};

export default RFamily;

const SummaryHousehold = ({ isMobile }: { isMobile: boolean }) => {
  const dispatch = useAppDispatch();
  const [myHouseholdState, setMyHouseholdState] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => { 
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.HOUSEHOLD, newValue);
  }

  const myHousehold = useAppSelector((store) => store.family.myHousehold);

  // Auto-Refresh myHouseholdState if database changed
  useEffect(() => {
    if (myHousehold?.student_id === Number(params.id)) {
      setMyHouseholdState({
        ...myHousehold,
        csu_info: checkEnableParseJSON(myHousehold?.csu_info),
        who_in_household_array: checkEnableParseJSON(myHousehold?.who_in_household_array),
      });
    
    }
  }, [myHousehold]);

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        let res:any = await dispatch(getHousehold(params.id)).unwrap();
        const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
          params.id === ':id' ? null : params.id,
          PAGE_NAME.HOUSEHOLD
        );
        setReviewedAndComplete(pageStatusResponse?.counselor_verified);
        setMyHouseholdState({
          ...res,
          csu_info: checkEnableParseJSON(res?.csu_info),
          who_in_household_array: checkEnableParseJSON(res?.who_in_household_array),
        });
      }
      catch(ex){
        console.log('Error: ', ex);
      }
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container mt-3">
      {myHouseholdState && (
        <>
          {/* Household Income and Size Information Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">
              Household Income and Size Information
            </div>
            <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
              Please review the following statements carefully to determine if any of them apply to you.
              Then, answer the question below.
            </div>
            <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
              <ul style={{ paddingLeft: '20px', margin: 0 }}>
                <li>You were born before January 1, 2004.</li>
                <li>You are currently an active-duty member or a veteran of the U.S. Armed Forces.</li>
                <li>As of today, you are married or you are separated, but not divorced.</li>
                <li>You have or will have children or dependents who will receive more than half of their support from you between July 1, 2027, and June 30, 2028.</li>
                <li>Someone other than your parent(s) or stepparent(s) has legal guardianship of you, as determined by a court in your state of legal residence.</li>
                <li>At any time since you turned age 13, both your parents were deceased, you were in foster care, or you were a dependent or ward of the court.</li>
                <li>At any time on or after July 1, 2026, your high school, an emergency shelter, a transitional housing program, or a homeless youth center determined you were an unaccompanied youth or were self-supporting and at risk of being homeless.</li>
                <li>You currently do not live with your parent(s)/stepparent(s) and have not had contact and no financial support from them for the last 12 months or more.</li>
              </ul>
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Do any of the above statements apply to you?*</div>
                <div className="gm-summary-field-value">
                  {myHouseholdState?.csu_info?.household_income_information_statements || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* Household Members Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">
              Household Members
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Who is in your household? (select all that apply)</div>
                <div className="gm-summary-field-value">
                  {householdOptions.map((option, index) => {
                    const key = option.key;
                    const formValues: any = myHouseholdState?.who_in_household_array ?? {
                      is_parent_guardian: false,
                      is_sibbling: false,
                      is_spouse: false,
                      is_child: false,
                    };
                    return (
                      <div key={index} style={{ marginBottom: '8px' }}>
                        <CheckboxContent label={option.value} values={formValues[key]} />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Household Size*</div>
                <div className="gm-summary-field-value">
                  {myHouseholdState?.household_size || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* Parent Education Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">
              Parent Education Information
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">What is the highest level of education earned by any of your parents?*</div>
                <div className="gm-summary-field-value">
                  {myHouseholdState?.highest_level_education_parent || '-'}
                </div>
              </div>
              {(myHouseholdState?.highest_level_education_parent === '2-year college graduate' ||
                myHouseholdState?.highest_level_education_parent === '4-year college graduate') && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Did this parent graduate within the last five years?</div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(myHouseholdState?.csu_info?.highest_level_education_parent_last_five_years) || '-'}
                  </div>
                </div>
              )}
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">What is your Parent/Guardian #1 highest level of education?</div>
                <div className="gm-summary-field-value">
                  {myHouseholdState?.csu_info?.parent_1_highest_level_education || '-'}
                </div>
              </div>
              {(myHouseholdState?.csu_info?.parent_1_highest_level_education === '2-year college graduate' ||
                myHouseholdState?.csu_info?.parent_1_highest_level_education === '4-year college graduate') && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Did this parent graduate within the last five years?*</div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(myHouseholdState?.csu_info?.parent_1_highest_level_education_last_five_years) || '-'}
                  </div>
                </div>
              )}
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">What is your Parent/Guardian #2 highest level of education?</div>
                <div className="gm-summary-field-value">
                  {myHouseholdState?.csu_info?.parent_2_highest_level_education || '-'}
                </div>
              </div>
              {(myHouseholdState?.csu_info?.parent_2_highest_level_education === '2-year college graduate' ||
                myHouseholdState?.csu_info?.parent_2_highest_level_education === '4-year college graduate') && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Did this parent graduate within the last five years?</div>
                  <div className="gm-summary-field-value">
                    {formatBooleanToYesNo(myHouseholdState?.csu_info?.parent_2_highest_level_education_last_five_years) || '-'}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Parental Marital Status Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">
              Parental Marital Status
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Parents'/Guardians' Marital Status (relative to each other)*</div>
                <div className="gm-summary-field-value">
                  {myHouseholdState?.parent_martial_status || '-'}
                </div>
              </div>
            </div>

            {myHouseholdState?.parent_martial_status === 'Divorced' && (
              <div className="gm-summary-conditional-section">
                <div className="gm-summary-conditional-title">
                  Divorce Information
                </div>
                <div className="gm-summary-field-grid">
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">Year of divorce*</div>
                    <div className="gm-summary-field-value">
                      {myHouseholdState?.year_of_divorce || '-'}
                    </div>
                  </div>
                  <div className="gm-summary-field-item">
                    <div className="gm-summary-field-label">Do you wish to list any step-parents?*</div>
                    <div className="gm-summary-field-value">
                      {(myHouseholdState?.is_listing_step_parents === true ||
                        myHouseholdState?.is_listing_step_parents === 'true') ? 'Yes' : 'No'}
                    </div>
                  </div>
                </div>
                {(myHouseholdState?.is_listing_step_parents === true ||
                  myHouseholdState?.is_listing_step_parents === 'true') && (
                  <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                      <div className="gm-summary-field-label">How many?*</div>
                      <div className="gm-summary-field-value">
                        {myHouseholdState?.how_many_step_parents || '-'}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">With whom do you make your permanent home?*</div>
                <div className="gm-summary-field-value">
                  {myHouseholdState?.whom_live_permanently || '-'}
                </div>
              </div>
              {myHouseholdState?.whom_live_permanently === 'Other' && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Other*</div>
                  <div className="gm-summary-field-value">
                    {myHouseholdState?.other_live_with_free_text || '-'}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Household Income Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">
              Household Income
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">What was the total income earned in 2025 by your parents or legal guardians?*</div>
                <div className="gm-summary-field-value">
                  {/* {myHouseholdState?.household_income || '-'} */}
                  XXXXXX
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">How many people were supported by this income?</div>
                <div className="gm-summary-field-value">
                  {myHouseholdState?.csu_info?.people_were_supported_by_this_income || '-'}
                </div>
              </div>
            </div>

            {myHouseholdState?.csu_info?.household_income_information_statements === 'None of the above statements apply to me' ? (
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Parents' adjusted gross income (AGI) for 2025. This is the income reported on your parent(s) federal tax return:*</div>
                  <div className="gm-summary-field-value">
                    {/* {myHouseholdState?.csu_info?.parent_gross_income || '-'} */}
                    XXXXXX
                  </div>
                </div>
              </div>
            ) : (
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Adjusted gross income (AGI) for 2025, all income reported on your federal tax return:*</div>
                  <div className="gm-summary-field-value">
                    {/* {myHouseholdState?.csu_info?.gross_income || '-'} */}
                    XXXXXX
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Dependents Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">
              Dependents
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Do you have any children?*</div>
                <div className="gm-summary-field-value">
                  {formatBooleanToYesNo(myHouseholdState?.is_have_any_children)}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">How many?*</div>
                <div className="gm-summary-field-value">
                  {myHouseholdState?.how_many_children || '-'}
                </div>
              </div>
            </div>
          </div>

          {
            getUserRole() === USER_ROLE.counselor && (
              <div className="gm-summary-checkbox-container">
                <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                  <input
                    type="checkbox"
                    style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid #6c757d',
                      borderRadius: '2px',
                    }}
                    onClick={onReviewdAndComplete}
                    checked={reviewedAndComplete}
                  />
                  <span
                    style={{
                      fontSize: isMobile ? '14px' : '12px',
                      color: '#6c757d',
                      fontWeight: '500',
                    }}
                  >
                    Reviewed & Complete!
                  </span>
                </div>
              </div>
            )
          }
        </>
      )}
    </div>
  );
};

const SummaryParent = ({ number, isMobile }: { number: 1 | 2, isMobile: boolean }) => {
  const [data, seData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => { 
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);

    const pageName = number === 1 ? PAGE_NAME.PARENT_1 : PAGE_NAME.PARENT_2;
    websocketService.finishReviewAndCompleteCounselor(pageName, newValue);
  }

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const pageName = number === 1 ? PAGE_NAME.PARENT_1 : PAGE_NAME.PARENT_2;
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        pageName
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);

      const parent =
        number === 1
          ? await familyServices.getParent1(params.id)
          : await familyServices.getParent2(params.id);
      seData(parent);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <Row className="w-100">
      <ParentSum dataValues={data} isParentNo2={number === 2} />

      {
        getUserRole() === USER_ROLE.counselor && (
          <div className="gm-summary-checkbox-container">
            <div className="d-flex align-items-center" style={{ gap: '6px' }}>
              <input
                type="checkbox"
                style={{
                  width: '16px',
                  height: '16px',
                  border: '2px solid #6c757d',
                  borderRadius: '2px',
                }}
                checked={reviewedAndComplete}
                onClick={onReviewdAndComplete}
              />
              <span
                style={{
                  fontSize: isMobile ? '14px' : '12px',
                  color: '#6c757d',
                  fontWeight: '500',
                }}
              >
                Reviewed & Complete!
              </span>
            </div>
          </div>
        )
      }
    </Row>
  );
};

const SummarySiblings = ({ isMobile }: { isMobile: boolean }) => {
  const [mySiblings, seMySiblings] = useState<any>({ parent1: null, parent2: null });
  const [loading, setLoading] = useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => { 
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.SIBLINGS, newValue);
  }
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const [res] = await Promise.all([familyServices.getSiblings(params.id)]);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.SIBLINGS
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      seMySiblings(res);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container mt-3">
      {mySiblings && (
        <>
          {/* Siblings Information Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">
              Siblings Information
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Please specify number of siblings you have*</div>
                <div className="gm-summary-field-value">
                  {mySiblings.number_of_siblings || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* Siblings Details Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">
              Siblings Details
            </div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Your siblings</div>
                <div className="gm-summary-field-value">
                  {(checkEnableParseJSON(mySiblings.siblings_array) || []).map((e: any, index: number) => (
                    <div key={index} style={{ marginBottom: '8px' }}>
                      {[e.fullName, e.relationship, e.educationLevel]
                        .filter((i) => !!i)
                        .join(' - ') || '-'}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {
            getUserRole() === USER_ROLE.counselor && (
              <div className="gm-summary-checkbox-container">
                <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                  <input
                    type="checkbox"
                    style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid #6c757d',
                      borderRadius: '2px',
                    }}
                    checked={reviewedAndComplete}
                    onClick={onReviewdAndComplete}
                  />
                  <span
                    style={{
                      fontSize: isMobile ? '14px' : '12px',
                      color: '#6c757d',
                      fontWeight: '500',
                    }}
                  >
                    Reviewed & Complete!
                  </span>
                </div>
              </div>
            )
          }
        </>
      )}
    </div>
  );
};

const SummaryLegalGuardian = ({ isMobile }: { isMobile: boolean }) => {
  const [myHouseholdState, setMyHouseholdState] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => {
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.LEGAL_GUARDIAN, newValue);
  }

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await familyServices.getHousehold(params.id === ':id' ? null : params.id);
      setMyHouseholdState({
        ...res,
        csu_info: checkEnableParseJSON(res?.csu_info),
        who_in_household_array: checkEnableParseJSON(res?.who_in_household_array),
      });
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.LEGAL_GUARDIAN
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <Row className="w-100">
      {myHouseholdState?.legal_guardian && (
        <LegalGuardianSum
          dataValues={myHouseholdState?.legal_guardian}
          label="Legal Guardian"
        />
      )}

      {
        getUserRole() === USER_ROLE.counselor && (
          <div className="gm-summary-checkbox-container">
            <div className="d-flex align-items-center" style={{ gap: '6px' }}>
              <input
                type="checkbox"
                style={{
                  width: '16px',
                  height: '16px',
                  border: '2px solid #6c757d',
                  borderRadius: '2px',
                }}
                checked={reviewedAndComplete}
                onClick={onReviewdAndComplete}
              />
              <span
                style={{
                  fontSize: isMobile ? '14px' : '12px',
                  color: '#6c757d',
                  fontWeight: '500',
                }}
              >
                Reviewed & Complete!
              </span>
            </div>
          </div>
        )
      }
    </Row>
  );
};

const SummaryStepParent = ({ isMobile }: { isMobile: boolean }) => {
  const [data, seData] = useState<any>({ stepParent1: null, stepParent2: null });
  const [loading, setLoading] = useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => { 
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.STEP_PARENT_1, newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.STEP_PARENT_2, newValue);
  }
  const role = useAppSelector((store) => store.family.roleFamily);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const [stepParent1, stepParent2] = await Promise.all([
        familyServices.getStepParent1(params.id),
        familyServices.getStepParent2(params.id),
      ]);
      const pageStatusResponse = await Promise.all([
        pageStatusService.getPageStatusByPageName(params.id === ':id' ? null : params.id, PAGE_NAME.STEP_PARENT_1),
        pageStatusService.getPageStatusByPageName(params.id === ':id' ? null : params.id, PAGE_NAME.STEP_PARENT_2),
      ]);
      setReviewedAndComplete(pageStatusResponse[0]?.counselor_verified && pageStatusResponse[1]?.counselor_verified);
      seData({ stepParent1, stepParent2 });
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <Row className="w-100">
      {/* <div className="fs-5 w-100">Step Parent No.1</div> */}
      {data.stepParent1 && <StepParentSum dataValues={data.stepParent1} label="Step Parent 1" />}
      {/* {role?.stepParent2 && <div className="fs-5 w-100">Step Parent No.2</div>} */}
      {data.stepParent2 && <StepParentSum dataValues={data.stepParent2} label="Step Parent 2" />}
      {
        getUserRole() === USER_ROLE.counselor && (
          <div className="gm-summary-checkbox-container">
            <div className="d-flex align-items-center" style={{ gap: '6px' }}>
              <input
                type="checkbox"
                style={{
                  width: '16px',
                  height: '16px',
                  border: '2px solid #6c757d',
                  borderRadius: '2px',
                }}
                checked={reviewedAndComplete}
                onClick={onReviewdAndComplete}
              />
              <span
                style={{
                  fontSize: isMobile ? '14px' : '12px',
                  color: '#6c757d',
                  fontWeight: '500',
                }}
              >
                Reviewed & Complete!
              </span>
            </div>
          </div>
        )
      }
    </Row>
  );
};
